<template>
  <div id="profile">
    <div class="intro-wrapper">
      <div class="content">
        <h2>{{ $t("settings.profile.title") }}</h2>
        <p class="description text-muted">
          {{ $t("settings.profile.message") }}
        </p>
      </div>
    </div>
    <div class="form-wrapper">
      <form @submit.prevent="onSave">
        <div class="heading">
          <h3>{{ $t('profile.pr-heading') }}</h3>
        </div>
        <div class="content">
          <div class="row">
            <div class="col-lg">
              <custom-input
                :isReadonly="true"
                :isDisabled="true"
                :inputType="'text'"
                v-model="$store.state.user.username"
                :name="'email'"
                :label="$t('profile.pr-email-label')"
                :placeholder="'Email'"
                :labelBG="'#f2f2f2'"
              />
            </div>

            <div class="col-lg">
              <custom-input
                v-model="form.name"
                :inputType="'text'"
                :name="'name'"
                :label="$t('profile.pr-name-label')"
                :placeholder="$t('profile.pr-name-label')"
                :labelBG="'#f2f2f2'"
              />
            </div>
          </div>
          <div class="row">
            <div class="select-dropdown col-lg-6">
              <label for="language">{{ $t("profile.pr-lang-label") }}</label>
              <select id="language" :placeholder="form.language" v-model="form.language">
                <option value="en">{{ $t("profile.pr-lang-en") }}</option>
                <option value="da">{{ $t("profile.pr-lang-da") }}</option>
              </select>
            </div>
          </div>

          <div class="buttons btns">
            <SaveButton
              :buttonText="$t('save')"
              :disabled="!infoChanged"
              :onSave="() => onSave()"
              :loading="saving"
              :saved="saveComplete"
              :saveErr="saveIncomplete"
              @saveCompleteHandled="saveComplete = false"
              @saveErrHandled="saveIncomplete = false"
              outline
            />

            <button
              class="btn btn-secondary"
              @click.prevent="onEditPassword"
              v-html="$t('password.new-pw-btn')"
            ></button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
let getSavedLanguage = () => {
  return localStorage.getItem(STORAGE_KEY);
};
const STORAGE_KEY = "language-storage";
import ChangePassword from "../components/modals/ChangePassword";
import CustomInput from "@/components/CustomInput";
import SaveButton from "@/components/SaveButton";
import appHelper from "@/assets/js/appHelper";
export default {
  components: {
    CustomInput,
    SaveButton
  },
  data() {
    return {
      savedLanguage: getSavedLanguage(),
      form: {
        name: "",
        language: ""
      },
      saving: false,
      succes: false,
      loading: false,
      saveComplete: false,
      saveIncomplete: false,
      fallbackLanguage: this.$store.getters.language
    };
  },
  methods: {
    async onSave() {
      if (this.infoChanged) {
        this.saving = true;
        this.loading = true;
        this.$store
          .dispatch("changeUserInfo", this.form)
          .then((res) => {
            this.saving = false;
            this.loading = false;
            this.saveComplete = true;
          })
          .catch((e) => {
            this.saving = false;
            this.loading = false;
            this.saveIncomplete = true;
          });
      }
      if (this.form.language != getSavedLanguage()) this.setLocale(this.form.language);
    },
    onEditPassword() {
      this.$modal.show(
        ChangePassword,
        {
          onNew: (model) => {
            this.loading = true;
          },
          onWrongPassword: (model) => {
            this.loading = false;
          },
          onClose: (model) => {
            this.loading = false;
          }
        },
        { width: 310, height: "auto", adaptive: true }
      );
    },
    setLocale(locale) {
      localStorage.setItem(STORAGE_KEY, locale);
      this.savedLanguage = locale;
      this.$i18n.locale = locale;
    }
  },
  computed: {
    infoChanged() {
      return (
        this.form.name !== this.$store.state.user.name ||
        this.form.language !== appHelper.getCountryCode(this.$store.state.user.language)
      );
    }
  },
  mounted() {
    this.form.name = this.$store.state.user.name;
    this.form.language = appHelper.getCountryCode(this.$store.state.user.language);
    if (!this.form.language) {
      this.form.language = this.fallbackLanguage;
    }
  }
};
</script>

<style lang="less">
#profile {
  // padding: 0 20px;
  padding-top: 103px;
  form {
    background-color: var(--background-white);
    border-radius: var(--standard-border-radius);
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.15);

    .heading {
      border-bottom: 1px solid var(--charcoal-20);
      padding: 12px 20px;
    }
    .content {
      padding: 12px 20px 18px;
    }
    button {
      margin: 30px 10px 10px 0px;
    }
  }
}

@media screen and (min-width: 920px) {
  #profile {
    display: grid;
    grid-template-columns: 3fr 7fr;
    gap: 42px;
    justify-content: space-between;

    .form-wrapper {
      display: flex;
      justify-content: flex-end;
      flex-grow: 1;
      form {
        flex-grow: 1;
        max-width: 800px;
      }
    }
  }
}
</style>
